import { useState } from "react";
import {
  Button,
  Card,
  CardImg,
  Row,
  CardBody,
  CardFooter,
  CardTitle,
} from "reactstrap";
import { formatDate, dateIsAfter } from "../../Utilities/dateUtils";
import PlusPackageVariantSelectModal from "../Modal/PlusPackageVariantSelectModal";
import PlusPackageVariantSelectOptionalModal from "../Modal/PlusPackageVariantSelectOptionalModal";
import AlertModal from "../Modal/AlertModal";
import { FormattedMessage, useIntl } from "react-intl";
import _ from "lodash";
import { LicenseTypes } from "../../constants/LicenseTypes";
import {
  AstarFortNoxArticleNumbers,
  AstarCustomerGroupId,
} from "../../constants/ConstantVars";

function ProductItem(props) {
  const intl = useIntl();
  const [selectForYearsModalIsOpen, setSelectForYearsModalIsOpen] =
    useState(false);
  const [selectedPlusPackage, setSelectedPlusPackage] = useState({});
  const [selectedPlusPackageVariant, setSelectedPlusPackageVariant] = useState({
    startDate: new Date(),
  });
  const [promptItemAlreadyInCart, setPromptItemAlreadyInCart] = useState(false);
  const [itemForPromptInfoOnPlusPackage, setItemForPromptInfoOnPlusPackage] =
    useState(null);
  const [choosenPremiumLicense, setChoosenPremiumLicense] = useState({
    startDate: new Date(),
  });

  const getFormattedPrice = (price) => {
    return props.currency === "SEK"
      ? `${price} kr`
      : `${props.currency} ${price}`;
  };

  let validTo = formatDate(props.product.validTo, "yyyy-MM-dd");
  let isValid = dateIsAfter(validTo);

  const textManagerFailMessages = (e) => {
    if (!e.enablePackage) {
      return intl.formatMessage({
        id: "OnlyAvailableForTeachersOnThisProgram",
      });
    } else if (!isValid) {
      return intl.formatMessage(
        { id: "YourProgramLicenseForProgramHasExpired" },
        {
          name: e.product.name,
        }
      );
    } else if (e.isPackagePurchase) {
      return intl.formatMessage({
        id: "PackageIsInCartNextStepChooseStudents",
      });
    } else if (e.isCoursePurchase) {
      return intl.formatMessage({
        id: "PackageIsInCartNextStepChooseStudents",
      });
    }
  };

  const handleAddOrSelectVariant = (product, productVariant) => {
    if (
      AstarFortNoxArticleNumbers.includes(product.fortnoxNumber) &&
      product.customerGroupId === AstarCustomerGroupId
    ) {
      setSelectedPlusPackage({
        product,
        productVariant: product.options.find(
          (item) => item.type === LicenseTypes.StudentLicense
        ),
      });

      const itemToAdd = {
        name: productVariant.name,
        costCenter: props.product.fortNoxCostCenter,
        fortnoxNumber: productVariant.fortnoxNumber,
        programLicenseId: props.product.programLicenseId,
        priceStudent: productVariant.priceStudent,
        years: null,
        validFrom: null,
        type: productVariant.type,
      };

      setItemForPromptInfoOnPlusPackage(null);
      setSelectForYearsModalIsOpen(false);
      props.handleOnAddPackage(itemToAdd);
    } else if (productVariant.options) {
      setSelectedPlusPackage({
        product: product,
        productVariant: productVariant,
      });
      setSelectForYearsModalIsOpen(true);
    } else {
      setSelectedPlusPackage({
        product: product,
        productVariant: product.options.find(
          (item) => item.type === LicenseTypes.StudentLicencePlus
        ),
      });
      const itemToAdd = {
        name: productVariant.name,
        costCenter: props.product.fortNoxCostCenter,
        fortnoxNumber: productVariant.fortnoxNumber,
        programLicenseId: props.product.programLicenseId,
        priceStudent: productVariant.priceStudent,
        years: null,
        validFrom: null,
        type: productVariant.type,
      };
      //Check if current package already is in cart
      setItemForPromptInfoOnPlusPackage(itemToAdd);
    }
  };

  const handleProceedToAddProgramLicenseToCart = (addPremium) => {
    if (
      !addPremium ||
      _.isEmpty(
        choosenPremiumLicense || _.isEmpty(choosenPremiumLicense.option)
      )
    ) {
      props.handleOnAddPackage(itemForPromptInfoOnPlusPackage);
    } else {
      const studentLicenseToAdd = props.product.options.find(
        (item) => item.type === LicenseTypes.StudentLicense
      );
      const plusPackageToAdd = choosenPremiumLicense.option;
      props.handleOnAddPackage(
        { ...studentLicenseToAdd, addedStudents: [] },
        {
          ...plusPackageToAdd,
          startDate: choosenPremiumLicense.startDate,
          addedStudents: [],
          programLicenseId: studentLicenseToAdd.programLicenseId,
          programName: studentLicenseToAdd.name,
          costCenter: studentLicenseToAdd.costCenter,
        }
      );
    }
    setChoosenPremiumLicense({ startDate: new Date() });
    setItemForPromptInfoOnPlusPackage(null);
  };

  const handleAddPackageWithYears = () => {
    const itemToAdd = {
      name: selectedPlusPackageVariant.option.name,
      costCenter: props.product.fortNoxCostCenter,
      fortnoxNumber: selectedPlusPackageVariant.option.fortnoxNumber,
      programLicenseId: props.product.programLicenseId,
      priceStudent: selectedPlusPackageVariant.option.priceStudent,
      years: selectedPlusPackageVariant.option.years,
      startDate: selectedPlusPackageVariant.startDate,
      type: selectedPlusPackage.productVariant.type,
      programName: props.product.programName,
    };
    props.handleOnAddPackage(itemToAdd);
    setSelectForYearsModalIsOpen(false);
  };

  const handleCloseselectForYearsModal = () => {
    setSelectedPlusPackageVariant({
      startDate: new Date(),
    });
    setSelectForYearsModalIsOpen(false);
  };

  const getButtonTitle = (licenseType) => {
    switch (licenseType) {
      case LicenseTypes.StudentLicense:
        return intl.formatMessage({
          id: "ProgramLicenseStoreInfo",
        });
      case LicenseTypes.StudentLicencePlus:
        return intl.formatMessage({
          id: "ProgramLicensePlusStoreInfo",
        });
      case LicenseTypes.PlusLicense:
        return intl.formatMessage({
          id: "OnlyPlusPackageStoreInfo",
        });
      default:
        return intl.formatMessage({
          id: "ProgramLicenseStoreInfo",
        });
    }
  };

  const cardFooterOk = (
    <CardFooter className="pb-2 pt-0">
      {props.product.options.map((productVariant, i) => {
        if (productVariant.type !== "StudentLicencePlus") {
          const isPlusPackage = productVariant.options;

          const isAstarLicense =
            isPlusPackage &&
            AstarFortNoxArticleNumbers.includes(props.product.fortnoxNumber) &&
            props.product.customerGroupId === AstarCustomerGroupId; // disable only plus package button for Astar

          const disabled = !isValid || !props.enablePackage || isAstarLicense;

          return (
            <Row className="pt-2 px-0" key={"productVariant" + i}>
              <div
                className="d-flex px-0"
                title={
                  props.isExpired
                    ? intl.formatMessage(
                        { id: "ProgramLicenseIsExpiredExpiredAt" },
                        {
                          date: formatDate(props.product.validTo,
                            "yyyy-MM-dd"
                          ),
                        }
                      )
                    : getButtonTitle(productVariant.type)
                }
                style={{
                  cursor: disabled ? "not-allowed" : "pointer",
                }}
              >
                <Button
                  className={`w-100 ${
                    isPlusPackage ? "plus-package-btn" : "standard-btn"
                  }`}
                  color={
                    disabled
                      ? "secondary"
                      : isPlusPackage
                      ? "primary"
                      : "success"
                  }
                  disabled={disabled}
                  onClick={() =>
                    handleAddOrSelectVariant(props.product, productVariant)
                  }
                >
                  <div className="btn-content">{productVariant.name}</div>
                  <div className="btn-price">
                    {!isPlusPackage ? (
                      <>
                        {getFormattedPrice(productVariant.priceStudent)}/licens
                      </>
                    ) : (
                      <>
                        <FormattedMessage id="From" />
                        {" " +
                          getFormattedPrice(props.cheapestPlusLicensePrice)}
                        /<FormattedMessage id="YearLower" />
                      </>
                    )}
                  </div>
                </Button>
              </div>
            </Row>
          );
        } else {
          return null;
        }
      })}
    </CardFooter>
  );

  const cardFooterNotOk = (
    <CardFooter
      style={{
        backgroundColor: "#2b313375",
        color: "#fff",
      }}
    >
      {textManagerFailMessages(props)}
    </CardFooter>
  );

  return (
    <>
      <Card
        outline
        className="bg-light m-0"
        title={
          props.isExpired
            ? intl.formatMessage(
                { id: "ProgramLicenseIsExpiredExpiredAt" },
                {
                  date: formatDate(props.product.validTo, "yyyy-MM-dd"),
                }
              )
            : !props.enablePackage
            ? intl.formatMessage({
                id: "OnlyAvailableForTeachersOnThisProgram",
              })
            : intl.formatMessage({
                id: "ClickChooseToStartCreatingStudentLicenses",
              })
        }
      >
        <CardImg
          top
          width="100%"
          src={
            props.product.imgUrl
              ? "img/" + props.product.imgUrl
              : props.product.name
                ? "img/" + props.product.name + ".jpg"
                : undefined
          }
          alt="Card image cap"
          height="160px"
        />
        {props.product?.name && (
          <CardTitle
            className={
              !isValid || !props.enablePackage
                ? "py-1 mb-0 text-center"
                : props.lastAddedProduct.id !== props.product.id
                ? "py-1 mb-0 text-center"
                : "py-1 mb-0 text-center"
            }
            style={{ backgroundColor: "#E4E5E6" }}
          >
            <strong>
              {props.product.name.includes("LearnWARE programlicens")
                ? props.product.name.replace("LearnWARE programlicens", "")
                : props.product.name}
            </strong>
          </CardTitle>
        )}
        {!props.enablePackage && (
          <CardBody className="mt-0 py-0">
            <CardTitle
              className="text-justify py-1 mb-0"
              title={props.product.packageName}
            >
              <strong>{props.product.packageName}</strong>
            </CardTitle>
          </CardBody>
        )}

        {!props.enablePackage ? cardFooterNotOk : cardFooterOk}
      </Card>

      <PlusPackageVariantSelectModal
        isOpen={selectForYearsModalIsOpen}
        toggle={() => handleCloseselectForYearsModal()}
        selectedPlusPackageVariant={selectedPlusPackageVariant}
        setSelectedPlusPackageVariant={setSelectedPlusPackageVariant}
        selectedPlusPackage={selectedPlusPackage}
        setSelectForYearsModalIsOpen={setSelectForYearsModalIsOpen}
        handleAddPackageWithYears={handleAddPackageWithYears}
        currency={props.currency}
        isStandAloneApl={false}
      />
      <PlusPackageVariantSelectOptionalModal
        isOpen={itemForPromptInfoOnPlusPackage !== null}
        toggle={() => setItemForPromptInfoOnPlusPackage(null)}
        onProceed={handleProceedToAddProgramLicenseToCart}
        selectedPlusPackageVariant={choosenPremiumLicense}
        setSelectedPlusPackageVariant={setChoosenPremiumLicense}
        selectedPlusPackage={selectedPlusPackage}
        setSelectForYearsModalIsOpen={setSelectForYearsModalIsOpen}
        currency={props.currency}
      />
      <AlertModal
        close={() => setPromptItemAlreadyInCart(false)}
        isOpen={promptItemAlreadyInCart}
        title={intl.formatMessage({
          id: "ProductIsAlreadyInCart",
        })}
        message={intl.formatMessage({
          id: "YouCanOnlyAddTheSameProductOnceInSameOrder",
        })}
      />
    </>
  );
}
export default ProductItem;
